import styled from "styled-components"

/* eslint-disable import/prefer-default-export */
export const FullWidthForm = styled.form`
  width: 100%;
  padding-top: ${({ theme }) => theme.space[3]}px;
`
